module.exports = __webpack_public_path__ + "img/rz.d66ea969.svg";